<template>
  <div>
    <b-card
      no-body
      :class="computedClass"
      @click="goPage(toPage)"
    >
      <b-card-body class="d-flex justify-content-between align-items-center">
        <div class="truncate">
          <h2
            v-if="Number(value) === Number(totals) || Number(totals) === 0"
            class="mb-25 font-weight-bolder"
          >
            <span v-if="prefix">{{ prefix }}</span>
            <span>
              {{ value | toNumber }}
            </span>
            <span v-if="suffix">{{ suffix }}</span>
          </h2>
          <h2
            v-else
            class="mb-25 font-weight-bolder"
          >
            <span v-if="prefix">{{ prefix }}</span>
            <span>
              {{ value | toNumber }}  / {{ totals | toNumber }}
            </span>
            <span v-if="suffix">{{ suffix }}</span>
          </h2>
          <span>{{ title }}</span>
          <div
            v-if="subTitle"
            class="font-small-2 text-muted"
          >
            {{ subTitle }}
          </div>
        </div>
        <b-avatar
          :variant="`light-${color}`"
          size="45"
        >
          <feather-icon
            size="21"
            :icon="icon"
          />
        </b-avatar>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {
  BAvatar, BCard, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'DefaultCard',
  components: {
    BAvatar, BCard, BCardBody,
  },
  props: {
    flatCard: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      required: true,
    },
    dataObject: {
      type: [Array, Object],
      default: null,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    totals: {
      type: [String, Number],
      default: '0',
    },
    prefix: {
      type: String,
      default: null,
    },
    suffix: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'primary',
    },
    toPage: {
      type: String,
      default: null,
    },
    dataModal: {
      type: Function,
      default: null,
    },
  },
  computed: {
    computedClass() {
      return {
        'link-card': this.toPage || this.dataObject,
        'flat-card': this.flatCard,
      }
    },
  },
  methods: {
    goPage(url) {
      if (url) {
        this.$router.push(url)
      } else if (this.dataModal && this.dataObject) {
        this.dataModal(this.dataObject)
      }
    },
  },
}
</script>
<style>
.flat-card{
  background-color: transparent !important;
  box-shadow: none !important;
}
.link-card{
  cursor: pointer !important;
}
</style>
